<dx-data-grid
  [dataSource]="locations"
  keyExpr="id"
  [showBorders]="true"
  [columnAutoWidth]="true"
  [hoverStateEnabled]="true"
  height="100%"
  (onToolbarPreparing)="onToolbarPreparing($event)">
  <dxo-paging [enabled]="false"></dxo-paging>
  <dxo-pager [visible]="false"></dxo-pager>
  <dxo-scrolling mode="standard"></dxo-scrolling>

  <dxi-column dataField="name" caption="Name"></dxi-column>
  <dxi-column dataField="location_type" caption="Type"></dxi-column>
  <dxi-column dataField="suburb" caption="Suburb"></dxi-column>
  <dxi-column dataField="state" caption="State"></dxi-column>
  <dxi-column dataField="location_token" caption="Token"></dxi-column>

  <dxi-column type="buttons" caption="Actions" [width]="120">
    <dxi-button hint="Edit" icon="edit" [onClick]="onEditClick"></dxi-button>
    <dxi-button hint="Delete" icon="trash" [onClick]="onDeleteClick"></dxi-button>
  </dxi-column>
</dx-data-grid>
